<!-- 上课单词列表 -->
<template>
<!-- 听音识词*2 消消乐*2 -->
    <el-row class="main-box">
				<el-col v-if="isokfx==0&&isfx==0" class="listdivcls " :offset="7" :span="9">
					<div style="position: relative;font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
						 单词识记
						 <div style="position: absolute;right: 30px;top: 5px;" class="flex-row f-center">
						 	<div @click="selefycode(0)"
						 	class="fh1" style="margin-right: 15px;" :style="fycode==0?'color: #0AA26B;border: 3px solid #0AA26B;':'color: #ACBEB0;border: 3px solid #ACBEB0;'">音</div>
						 	<div @click="selefycode(1)"
						 	class="fh1"  :style="fycode==1?'color: #0AA26B;border: 3px solid #0AA26B;':'color: #ACBEB0;border: 3px solid #ACBEB0;'">原</div>
						 </div>
					</div>
					
					<div  :style="indexdata==showindex?'background: #B6E4D3':indexdata==oneindexcru?'border-left:2px solid #0AA26B':''" 
					class="itembgcls flex-row f-align-center"  
					v-for="(itemdata, indexdata) in datalist" :key="indexdata" 
					@click="ontdclick(itemdata.id,indexdata)" >
						<div v-if='!(indexdata==showindex&&oneclick>1)' class="flex1" style="margin-left: 13px;text-align: start;"  :class="fycode==0?'myzit':''"   >{{fycode==0?itemdata.phonetic:itemdata.word}}</div>
						<div  v-if='indexdata==showindex&&oneclick==1' style="margin-right: 13px;text-align: end;">{{itemdata.chinese}}</div>
					</div> 
					<div style="position: relative;font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;margin-top: 46px;">
						{{crpage}}/{{numpage}}
						<div class="xiyibclss" @click="nexclic()">
							下一关
						</div>
						</div>
				</el-col>
				
				<el-col v-else-if="isokfx==0&&isfx==1" class="listdivcls" :offset="7" :span="9">
					<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
						 本组复习
						 </div>
					<div  :style="indexdata==showindex?'background: #B6E4D3':''" class="itembgcls flex-row f-align-center"  v-for="(itemdata, indexdata) in datalist"
					 :key="indexdata" @click="ontdclick(itemdata.id,indexdata)" >
						<div v-if='!(indexdata==showindex&&oneclick>1)' class="flex1" style="margin-left: 13px;text-align: start;" >{{itemdata.word}}</div>
							<div  v-if='indexdata==showindex&&oneclick==1' style="margin-right: 13px;text-align: end;">{{itemdata.chinese}}</div>
							</div> 
					<div style="position: relative;font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;margin-top: 46px;">
						{{crpage}}/{{numpage}}
						<div class="xiyibclss" @click="nexclic()">
							下一关
						</div>
						</div>
				</el-col>
				
				<el-col v-else-if="isokfx==0&&isfx==2" class="listdivcls" :offset="7" :span="9">
					<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
						 听音识词
						 </div>
					<div  :style="indexdata==showindex?'background:#B6E4D3':indexdata==nextindex?'border-left:2px solid #0AA26B':''"
					 class="itembgcls flex-row f-align-center"  v-for="(itemdata, indexdata) in datalist" 
					 :key="indexdata" @click="requsturl3(itemdata.id,indexdata)" >
						<div v-if='!(indexdata==showindex&&oneclick>1)' class="flex1" style="margin-left: 13px;text-align: start;" >{{itemdata.word}}</div>
					 	<div  v-if='indexdata==showindex&&oneclick==1' style="margin-right: 13px;text-align: end;">{{itemdata.chinese}}</div>
					</div> 
					<div style="position: relative;font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;margin-top: 46px;">
						{{crpage}}/{{numpage}}
							<div class="xiyibclss" @click="nexclic2()">
								下一个
							</div>
						</div>
				</el-col>
				
				<el-col v-else-if="isokfx==0&&(isfx==3||isfx==4)" :offset="7" :span="9">
					<div  class="listdivcls">
					<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
						 消消乐 第{{crpage}}组
						 </div>
								<div  v-for="(itemdata, indexdata) in datalist1" :key="indexdata" >
									<transition     leave-active-class="animate__animated animate__bounceOutUp" :duration="{ enter: 200, leave: 600 }" mode="out-in">
										<div v-if="showindex2!=indexdata"  class="itembgcls flex-row f-align-center"  >
										<div  class="flex1" style="margin-left: 13px;text-align: start;" @click="requsturl(itemdata.id,indexdata)" >{{showindex1==indexdata?itemdata.chinese:itemdata.word}}</div>
										<img class="imagwh" style="margin-right: 13px;" mode="fill"  @click="remDataxxl(indexdata)"  :src="require('@/static/jd2_check3_1.png')"/>
										</div>
									</transition>
								</div> 
					<div style="position: relative;font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;margin-top: 46px;">
						{{crpage}}/{{numpage}}
						</div>
					</div>
					<div class="flex-row f-center">
							<img v-if="isfx==3||isfx==4" style="width: 130px;height: 150px;"  mode="fill"  :src="require('@/static/jd2_jixw_ic1.png')"/>
							<img v-if="isfx==4" style="width: 130px;height: 150px;margin-left: 26px;" mode="fill"   :src="require('@/static/jd2_jixw_ic2.png')"/>
					</div>
				</el-col>
				
				
				<el-col v-else-if="isokfx==0&&isfx==5" class="listdivcls" :offset="7" :span="9">
					<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
						消消乐 第{{crpage}}组
						 </div>
					<div class="bucls3" @click="re5start" style="margin-top:41px ;">
							重新检测
						</div>
					<div class="bucls4" @click="click5next()" style="margin-top:21px ;">
						<!-- 混合检测  下一组  混合全部 -->
						{{get5nexttitle()}}
					</div>
				</el-col>
				
			
				
				
				
				<el-col v-else-if="isokfx==0&&(isfx==6||isfx==7)" class="listdivcls" :offset="7" :span="9">
					<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
						 {{gettitemc()}}
						 </div>
					<div  class="itembgcls flex-row f-align-center" v-for="(itemdata, indexdata) in data1" :key="indexdata" >
						<div class="flex1" style="margin-left: 26px;text-align: start;"  @click="requsturl2(itemdata.id,indexdata)">{{showindex==indexdata?itemdata.chinese:itemdata.word}}</div>
						<img class="imagwh" style="margin-right: 26px;" mode="fill"  @click="remData(indexdata)"  :src="require('@/static/jd2_check3_1.png')"/>
					</div>
				</el-col>
				
				<el-col v-else-if="isokfx==0&&isfx==8" class="listdivcls" :offset="7" :span="9">
					<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
						{{gettitemc()}}
						 </div>
					<div class="bucls3" @click="re8start" style="margin-top:41px ;">
							重新检查
						</div>
					<div class="bucls4" @click="get8nextclick()" style="margin-top:21px ;">
						{{get8nexttitle()}}
					</div>
				</el-col>
				
				<el-col v-else-if="isokfx==1||isokfx==2" class="listdivcls " :offset="7" :span="9">
					<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
						混合消消乐
						 </div>
					<div  class="itembgcls flex-row f-align-center" v-for="(itemdata, indexdata) in data1" :key="indexdata" >
						<div class="flex1" style="position: relative;margin-left: 26px;text-align: start;" >
						
							<div>{{showindex==indexdata?itemdata.chinese:itemdata.word}}</div>
						<div  class="flex-row"  style="top: 0;position: absolute;width: 100%;height: 80px;z-index: 12;">
							<div click="flex1" @click="requsturl_new1(itemdata.id,indexdata)" style="height: 80px;width: 100%;"></div>
							<div click="flex1" @click="requsturl_new2(itemdata.id,indexdata)"  style="height: 80px;width: 100%;"></div>
						</div>
						</div>
						<img class="imagwh" style="margin-right: 26px;" mode="fill"  @click="remDatahhe(indexdata)"  :src="require('@/static/jd2_check3_1.png')"/>
					</div>
				</el-col>
				
				
				<el-row v-else   >
							<el-col class="listdivcls " :offset="7" :span="9">
								<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
									学后检测</div>
								<div  class="itembgcls flex-row f-align-center" v-for="(itemdata, indexdata) in data" :key="indexdata">
									<div class="flex1" style="position: relative;margin-left: 26px;text-align: start;" >
									<div>{{showindex==indexdata?itemdata.chinese:itemdata.word}}</div>
									<div  class="flex-row"  style="top: 0;position: absolute;width: 100%;height: 80px;z-index: 12;">
										<div click="flex1" @click="requsturl_new1(itemdata.id,indexdata)" style="height: 80px;width: 100%;"></div>
										<div click="flex1" @click="requsturl_new2(itemdata.id,indexdata)"  style="height: 80px;width: 100%;"></div>
									</div>
									</div>
									<img  class="imagwh" style="margin-right: 6px;" mode="fill" @click="addzq(indexdata)"  :src="itemdata.isGrasp==1? require('@/static/jd_check1_1.png'):require('@/static/jd_check1_0.png')"/>
									<img class="imagwh" style="margin-right: 26px;" mode="fill"  @click="addcw(indexdata)"  :src="itemdata.isGrasp==0?require('@/static/jd_check2_1.png'):require('@/static/jd_check2_0.png')"/>
								</div>
							</el-col>
							<el-col :span="4">
								<div class="xcls flex-column "  style="position: fixed;width: 13%;margin-left: 30px"> 
									<div class="dccls flex-row f-center" style="margin-top: 20px;">
										<span class="text11">全部</span>
										<span class="text12" style="margin-left: 10px;margin-right: 5px;">{{data.length}}</span>
										<span class="text13">单词</span>
									</div>
									<div class="flex-row f-center" style="margin-top: 20px;">
										<span class="text14">正确</span>
										<span class="text16" style="color: #0AA26B;">{{zqnum}}</span>
										<div  class="text17" ></div>
										<span class="text15">待学</span>
										 <span class="text16" style="color: #F4CB22;">{{cwnum}}</span>
									</div>
									<div class="bucls1" @click="sumclick()" style="margin-top:21px ;">
										提交
									</div>
								<!-- 	<div class="bucls2" @click="finish()" style="margin-top:21px ;">
										返回
									</div> -->
								</div>
							</el-col>
				</el-row>
				
				<audio   ref="audio">
					<source :src="playsrc" type="audio/mp3"/>
				</audio>
				<div v-if="showtime" style="font-size: 18px;color: #67c23a;position: absolute;top: 84px;right: 10px; background: #f0f9eb;padding: 10px 15px;border: 1px solid #ebf7e5;border-radius: 5px;">课程倒计时{{djtimer}}</div>
    </el-row>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import { bottom } from '@popperjs/core';
export default {
    data() {
        return {
			datalist:[
			],
			datalist1:[
			],
			data:[
			],
			data1:[
			],
			planId:"",
			recordId:"",
			courseId:"",
			zqnum:0,
			cwnum:0,
			dialogConfrimStartClass:false,
			playsrc:"",
			numpage:1,//总数
			crpage:1,//当前数
			isfx:0,//当页码步数
			isokfx:0,// 是否ok  混剪2遍
			isplay:false,
			showindex:-1,
			nextindex:0,//下一個坐標位置
			showindex1:-1,//消消乐定时指针
			showindex2:-1,//消消乐动画指针
			timer: null,//
			oneclick:0,
			isdaoxu:false,//是否倒序
			timer2: null,
			timer3: null,
			
			indexdata:[],
			oneindexlenght:0,
			oneindexcru:0,
			fycode:0,
			showtime:false,//是否展示倒计时
			showclasstimer: null,//
			djtimer:"00:00",
			}
    },
    computed: {
      ...mapState([
          'userToken',
		   'userInfos',
      ]),
      ...mapGetters(["getUserToken"])
    },
	created() {
		this.courseId =this.$route.params.courseId;
		this.data =this.$route.params.data;
		
		this.recordId =this.$route.params.recordId;
		this.countdown = this.$route.params.countdown;
		for(var i=0;i<this.data.length;i++)
		{
			this.data[i].isGrasp=null;
		}
		this.initdata();
		this.timeFn();
	},
	beforeDestroy() {  
	     this.showclasstimer && clearInterval(this.showclasstimer)
	},
    methods: {
		timeFn() {
			var timestamp = new Date().getTime();
			if(this.countdown-timestamp<0)
			{
				this.djtimer="00:00";
				return;
			}
			this.countdownleng=Math.floor((this.countdown-timestamp)/1000);
		     this.showclasstimer = setInterval(() => {
					console.log("~~~~"+this.countdownleng);
		                if (this.countdownleng > 0) {
		                    this.countdownleng--;
								// 5*60
							if(this.countdownleng<5*60)	
							{
								this.showtime=true;
								this.djtimer=this.formatSecound( this.countdownleng);
							}
		                } else {
		                    clearInterval(this.showclasstimer);
		                }
		     }, 1000);
		   },
		   formatSecound(seconds){
		   	 var m=seconds ;
		   	var hour=Math.floor(m/60) ;
		   	var minutest=m%60;
		   	if(minutest<10)
		   	{
		   		return hour+":0"+minutest;
		   	}
		   	return hour+":"+minutest;
		   },
		selefycode(ty){
			this.fycode=ty;
		}
		,
		gettitle(){
			
		},
		iniindexdata(length){
			if(length==5)
			{
				this.indexdata=[1,2,1,2,3,2,1,2,3,4,3,2,1,2,3,4,5,4,3,2,1,5,4,5,4,3,4,5,4,3,2,3,4,5,4,3,2,1,2,3,4,5];
			}else if(length==4)
			{
				this.indexdata=[1,2,1,2,3,2,1,2,3,4,3,2,1,4,3,4,3,2,3,4,3,2,1,2,3,4];
			}else if(length==3)
			{
			this.indexdata=[1,2,1,2,3,2,1,3,2,3,2,1,2,3];	
			}else if(length==2)
			{
				this.indexdata=[1,2,1,2,1,2];
			}else
			{
				this.indexdata=[1];
			}
		},
		dialogConfrim(){
			this.dialogConfrimStartClass=true;
		},
		re5start(){
			//第五步 重新检查
			this.datalist1= JSON.parse(JSON.stringify(this.datalist));
			this.isfx=3; //回到第三步
			this.showindex=-1;
		},
		get5nexttitle(){
			//第五步 点击情况
			if(this.crpage==1&&this.numpage==1)
			{
				return "混合全部";
			}else if(this.crpage==1&&this.numpage>1)
			{
				return "下一组";
			}else{
				return "混合检测";
			}
			this.showindex=-1;
		},
		click5next()
		{
			this.showindex=-1;
			//第五步 标题三种情况
			// 混合检测  下一组  混合全部 
			if(this.crpage==1&&this.numpage==1)
			{
				this.data1= JSON.parse(JSON.stringify(this.data));
				this.isokfx=1;
			}else if(this.crpage==1&&this.numpage>1)
			{
				this.nexclic();
			}else{
				//第6步
				if(this.numpage>this.crpage){
						this.data1=JSON.parse(JSON.stringify(this.data.slice(0,this.crpage*5)));
				}else{
					this.data1= JSON.parse(JSON.stringify(this.data));
				}
				this.isfx++;
			}
		},
		get8nexttitle(){
			//第八步 点击情况
			if(this.crpage==this.numpage)
			{
				return "混合全部";
			}else 
			{
				return "下一组";
			}
		},
		get8nextclick(){
			this.showindex=-1;
			//第八步 点击情况
			if(this.crpage==this.numpage)
			{
				this.data1= JSON.parse(JSON.stringify(this.data));
				this.isokfx=1;
			}else 
			{
				this.nexclic();
			}
		},
		re8start(){
			//第八步 重新检查
			if(this.numpage>this.crpage){
					this.data1=JSON.parse(JSON.stringify(this.data.slice(0,this.crpage*5)));
			}else{
				this.data1= JSON.parse(JSON.stringify(this.data));
			}
			this.isfx=6; //回到第三步
		},
		gettitemc(){
			var title="";
			for(var i=1;i<=this.crpage;i++){
				title+=i+","
			}
			if(title.length>0)
			{
				title=title.substr(0,title.length-1);
			}
			return "消消乐 第"+title+"组";
		},
		async ontdclick(id,index)
		{
			// 单词识记
			if(this.showindex!=index)
			{
				this.showindex=index;
				this.oneclick=0;
				
				if(this.showindex==this.oneindexcru)
				{
					this.oneindexlenght++;
					this.oneindexcru=this.indexdata[this.oneindexlenght]-1;
				}
		
				
			}else{
				if(	this.oneclick>1){
					this.oneclick=0;
				}else{
						this.oneclick++;
				}
			}
			if(this.oneclick==0)
			{
				if(this.isplay)
				{
					return;
				}
				this.isplay=true;
				    let res = await this.$api.get("/web/teacher/home/selectWordPronunciation", {
				        headers: { //头部参数
				            frontUserToken: this.getUserToken
				        },
						params:{
							id :id,
						 }
				    });
					this.isplay=false;
					if(res.code==200)
					{
						this.play(res.data.pronunciation);
					}
			}
			
		},
		nexclic(){
			this.showindex=-1;
			this.isdaoxu=false;
			this.oneclick=0;
			//下一关
			//有没有复习过  没有
			if(this.isfx<5)
			{
				// for(var i=0;i<this.datalist.length;i++)
				// {
				// 		this.datalist[i].isGrasp=null;
				// }
				this.isfx++;
				if(this.isfx==3||this.isfx==4)
				{
					this.datalist1=JSON.parse(JSON.stringify(this.datalist));
				}
			}else{
				//有没有下一页
				if(this.crpage>=this.numpage)
				{
					//，没有下一页了
					console.log("沒有下一頁了");
					this.data1= JSON.parse(JSON.stringify(this.data));
					this.isokfx=1;
				}else{
					this.crpage++;
					if(this.crpage==this.numpage)
					{
						var datalistcp = JSON.parse(JSON.stringify(this.data.slice(5*(this.crpage-1),this.data.length)));
						this.datalist=datalistcp;
					}else{
						var datalistcp = JSON.parse(JSON.stringify(this.data.slice(5*(this.crpage-1),5*(this.crpage-1)+5)));
						this.datalist=datalistcp;
					}
					this.isfx=0;
					this.nextindex=0;
					this.iniindexdata(this.datalist.length);
					this.oneindexlenght=0;
					this.oneindexcru=this.indexdata[this.oneindexlenght]-1;
				}
			}
		},
		nexclic2(){
				if(this.nextindex<0){
					this.nexclic();
					return;
				}
				this.requsturl3(this.datalist[this.nextindex].id,this.nextindex);
		},
		async requsturl3(id,index){
			if(this.isplay)
			{
				return;
			}
			if(this.showindex!=index)
			{
				this.showindex=index;
				this.oneclick=0;
			}else{
				if(	this.oneclick>1){
					this.oneclick=0;
				}else{
				this.oneclick++;
				}
			}
			
			
			if(this.nextindex==this.showindex)
			{
				if(!this.isdaoxu)
				{
						if(this.showindex==(this.datalist.length-1))
						{
							this.isdaoxu=true;
							this.nextindex=this.showindex-1;
						}else{
							this.nextindex=this.showindex+1;
						}
				}else{
					//下到上
					this.nextindex=this.showindex-1;
				}	
			}
			
			if(this.oneclick==0){
				this.isplay=true;
			    let res = await this.$api.get("/web/teacher/home/selectWordPronunciation", {
			        headers: { //头部参数
			            frontUserToken: this.getUserToken
			        },
					params:{
						id :id,
					 }
			    });
				this.isplay=false;
				if(res.code==200)
				{
					this.play(res.data.pronunciation);
				}
		}
		},
		async requsturl(id,index){
			if(this.isplay)
			{
				return;
			}
			this.showindex=index;
			this.isplay=true;
			    let res = await this.$api.get("/web/teacher/home/selectWordPronunciation", {
			        headers: { //头部参数
			            frontUserToken: this.getUserToken
			        },
					params:{
						id :id,
					 }
			    });
				this.isplay=false;
				if(res.code==200)
				{
					this.play(res.data.pronunciation);
				}
		},
		async requsturl2(id,index){
			if(this.isplay)
			{
				return;
			}
			this.showindex=index;
			this.clearTimer();
			 this.timer = setTimeout(() => {
			  this.showindex=-1;
			  }, 4000);
			this.isplay=true;
			 let res = await this.$api.get("/web/teacher/home/selectWordPronunciation", {
			        headers: { //头部参数
			            frontUserToken: this.getUserToken
			        },
					params:{
						id :id,
					 }
			    });
				this.isplay=false;
				if(res.code==200)
				{
					this.play(res.data.pronunciation);
				}
		},
		async requsturl_new2(id,index){
			this.showindex=index;
			this.clearTimer();
			 this.timer = setTimeout(() => {
			  this.showindex=-1;
			  }, 4000);
		},
		async requsturl_new1(id,index){
			if(this.isplay)
			{
				return;
			}
			this.isplay=true;
			 let res = await this.$api.get("/web/teacher/home/selectWordPronunciation", {
			        headers: { //头部参数
			            frontUserToken: this.getUserToken
			        },
					params:{
						id :id,
					 }
			    });
				this.isplay=false;
				if(res.code==200)
				{
					this.play(res.data.pronunciation);
				}
		},
		clearTimer () {
		    this.timer && clearInterval(this.timer)
		 },
		 clearTimer1 () {
		     this.timer2 && clearInterval(this.timer2)
		  },
		  clearTimer3 () {
		      this.timer3 && clearInterval(this.timer3)
		   },
		play(url)
		{
			this.playsrc=url;
			let music1 = new Audio();
			music1 = url;
		    this.$refs.audio.src = music1;
			let audioPlayer = this.$refs.audio;
			audioPlayer.playbackRate = 1.2;
			this.$refs.audio.play();
		},
		remData(indexdata){
			this.showindex=-1;
			this.clearTimer();
			
			if(this.data1.length>1)
			{
				this.data1.splice(indexdata,1);
			}else{
				this.data1.splice(indexdata,1);
				if(this.isfx==6)
				{
					if(this.numpage>this.crpage){
							this.data1=JSON.parse(JSON.stringify(this.data.slice(0,this.crpage*5)));
					}else{
						this.data1= JSON.parse(JSON.stringify(this.data));
					}
				}
				this.isfx++;
			}
		},
		remDatahhe(indexdata){
			this.showindex=-1;
			this.clearTimer();
			if(this.data1.length>1)
			{
				this.data1.splice(indexdata,1);
			}else{
				this.data1.splice(indexdata,1);
				if(this.isokfx==1)
				{
					this.isokfx=3;
					// this.data1= JSON.parse(JSON.stringify(this.data));
				}else{
					this.isokfx++;
				}
				
			}
		},
		 getRandomInt(min, max) { 
		  return Math.floor(Math.random() * (max - min + 1) + min) // +1是保证能够取到上限值
		}, shuffle(arr) {  
		  let _arr = arr.slice()   // 下面会讲到slice的特别之处
		  for (let i = 0; i < _arr.length; i++) {
		    let j = this.getRandomInt(0, i)
		    let t = _arr[i]
		    _arr[i] = _arr[j]
		    _arr[j] = t
		  }
		  return _arr
		},
		remDataxxl(indexdata){
			if(this.showindex2!=-1)
			{
				return;
			}
			this.clearTimer1();
			
			if(this.isfx==4)
			{
					
							this.showindex2=indexdata;
							this.showindex1=-1;
							this.clearTimer3();
							this.timer3 = setTimeout(() => {
							 if(this.datalist1.length>1)
							 {
								this.datalist1.splice(this.showindex2,1);
							 }else{
								this.datalist1= JSON.parse(JSON.stringify(this.datalist));
									this.isfx++;
							 }
							  this.showindex2=-1;
							 }, 600);
			}else{
				this.showindex1=indexdata;
				var self=this;
				this.timer2 = setTimeout(() => {
						this.showindex2=this.showindex1;
						this.showindex1=-1;
						this.clearTimer3();
						this.timer3 = setTimeout(() => {
						 if(this.datalist1.length>1)
						 {
							this.datalist1.splice(this.showindex2,1);
						 }else{
							this.datalist1= JSON.parse(JSON.stringify(this.datalist));
								this.isfx++;
						 }
						  this.showindex2=-1;
						 }, 600);
				 }, 500);
			}
			
		},
		addzq2(index){
			if(this.datalist[index].isGrasp==1)
			{
				return;
			}
			this.datalist[index].isGrasp=1;
			this.jcdata();
		},
		addcw2(index){
			if(this.datalist[index].isGrasp==0)
			{
				return;
			}
			this.datalist[index].isGrasp=0;
			this.jcdata();
		},
		jcdata(){
			//检查数据
			var ismadata=false; //是不是都填完了
			for(var i=0;i<this.datalist.length;i++)
			{
				if(this.datalist[i].isGrasp!=1&&
				this.datalist[i].isGrasp!=0){
					ismadata=true;
					break;
				}
			}
			if(ismadata)
			{
				return;
			}
			//有没有复习过  没有
			if(this.isfx!=4)
			{
					for(var i=0;i<this.datalist.length;i++)
					{
						this.datalist[i].isGrasp=null;
					}
				this.isfx++;
			}else{
				//有没有下一页
				if(this.crpage>=this.numpage)
				{
					//，没有下一页了
					console.log("沒有下一頁了");
					this.data1= JSON.parse(JSON.stringify(this.data));
					this.isokfx=1;
				}else{
					this.crpage++;
					if(this.crpage==this.numpage)
					{
						var datalistcp = JSON.parse(JSON.stringify(this.data.slice(5*(this.crpage-1),this.data.length)));
						this.datalist=datalistcp;
					}else{
						var datalistcp = JSON.parse(JSON.stringify(this.data.slice(5*(this.crpage-1),5*(this.crpage-1)+5)));
						this.datalist=datalistcp;
					}
					this.isfx=0;
					this.nextindex=0;
					this.iniindexdata(this.datalist.length);
					this.oneindexlenght=0;
					this.oneindexcru=this.indexdata[this.oneindexlenght]-1;
				}
			}
		},
		async sumclick(){
			// Loading.service();
			let res = await this.$api.post("/web/teacher/attendClass/learnWordDataTwoSubmit",{
				courseId:this.courseId,
				learnWordDetailVos:this.data,
				planId:this.planId,
				recordId:this.recordId,
			} ,{
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    }
			});
			if(res.code==200)
			{
				this.$message({
				  type: "success",
				  message: "提交成功"
				});
				this.$router.back();
			}else{
				this.$message({
				  type: "warning",
				  message: res.msg
				});
			}
		},
		 finish(){
			this.$router.back();
		 },
		 initdata() {
			if(this.data==null||this.data.length==0)
			{
				this.$message({
				type: "warning",
				  message: "数据错误!"
				});
				this.$router.back();
			}
			this.numpage=Math.ceil( this.data.length/5);
			this.crpage=1;
			
			if(this.crpage==this.numpage)
			{
				var datalistcp = JSON.parse(JSON.stringify(this.data.slice(5*(this.crpage-1),this.data.length)));
				this.datalist=datalistcp;
			}else{
				var datalistcp = JSON.parse(JSON.stringify(this.data.slice(5*(this.crpage-1),5*(this.crpage-1)+5)));
				this.datalist=datalistcp;
			}
			this.iniindexdata(this.datalist.length);
			this.oneindexcru=this.indexdata[0]-1;
		},
		addzq(index){
			if(this.data[index].isGrasp==1)
			{
				return;
			}
			
			if(this.data[index].isGrasp==0)
			{
				this.cwnum--;
			}
			this.data[index].isGrasp=1;
			this.zqnum++;
		},
		addcw(index){
			if(this.data[index].isGrasp==0)
			{
				return;
			}
			
			if(this.data[index].isGrasp==1)
			{
				this.zqnum--;
			}
			this.data[index].isGrasp=0;
			this.cwnum++;
		},
		
    }
}
</script>

<style lang="scss" scoped>
	  @import '../../src/font.css';
.main-box {
    width: 100%;
	flex: 1;
    background: #B6E4D3;
    position: relative;
	padding-top: 84px;
	
	.listdivcls{
	  border-radius: 20px;
	  background: #E5F3F1;
	  padding-top: 21px;
	  padding-bottom: 21px;
	  font-family: Oswald;
	  font-size: 30px;
	  font-weight: normal;
	  line-height: normal;
	  text-align: center;
	  letter-spacing: 0em;
	  font-feature-settings: "kern" on;
	  /* 绿 */
	  color: #0AA26B;
	  
	  
	@media screen and (max-width: 1400px)  {
	 	  font-size: 25px;
	 }
	 
	 @media screen and (max-width: 1000px)  {
	  	  font-size: 18px;
	  }
	}
	
	.xiyibclss{
		position: absolute;
		right: 21px;
		cursor: pointer;
		text-align: center;
		// width: 210px;
		width: 15%;
		height: 40px;
		top: 0;
		border-radius: 100px;
		/* 绿 */
		background: #0AA26B;
		font-family: Source Han Sans CN;
		font-size: 16px;
		font-weight: bold;
		line-height: 40px;
		letter-spacing: 0em;
		font-feature-settings: "kern" on;
		/* 纯白 */
		color: #FFFFFF;
	}
	
	.itembgcls_selec{
		// background: #B6E4D3;
				background: red;
	}
	
	.itembgcls{
		cursor: pointer;
		/* 矩形 55 */
		margin-left: 30px;
		margin-right: 30px;
		height: 80px;
		border-radius: 20px;
		opacity: 1;
		margin-top: 23px;
		/* 纯白 */
		background: #FFFFFF;
		box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
		
		
	.imagwh{
			width: 35px;
			height: 35px;
			
			 @media screen and (max-width: 1400px)  {
				width: 25px;
				height: 25px;
			}
			
			@media screen and (max-width: 1000px)  {
				width: 10px;
				height: 10px;
			}
		}
	}
	
	.xcls{
		height: 307px;
		border-radius: 20px;
		opacity: 1;
		background: #FFFFFF;
		
		
		.dccls{
			margin-left: 15px;
			margin-right: 15px;
			height: 76px;
			border-radius: 20px;
			opacity: 1;
			background: linear-gradient(330deg, #FFFFFF 14%, #D9F1E5 77%);
			box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);
	
		}
		
		.text11{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 已选择 */
			font-family: 思源黑体;
			font-weight: 400;
			font-size: 18;
			color: #ACBEB0;
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		.text12{
			font-family: Oswald;
			font-size: 36px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 20px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 10px;
			  }
		}
		
		.text13{
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;
			font-family: Source Han Sans;
			font-weight: 400;
			font-size: 18px;
			color: #333333;
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		
		.text14{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		.text15{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 红 */
			color: #F4CB22;
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		.text16{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			margin-left: 19px;
			font-feature-settings: "kern" on;
		
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
				  margin-left: 10px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
				  margin-left: 8px;
			  }
		}
		
		
		.text17{
			width: 10%;
			
		
		}
		.bucls1{
			margin-left: 15px;
			margin-right: 15px;
			 cursor: pointer;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			text-align: center;
			/* 绿 */
			background: #0AA26B;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: bold;
			line-height: 46px;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 纯白 */
			color: #FFFFFF;
		}
		
		.bucls2{
			margin-left: 15px;
			margin-right: 15px;
			 cursor: pointer;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			
			box-sizing: border-box;
			/* 绿 */
			border: 2px solid #0AA26B;
			text-align: center;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: normal;
			line-height: 46px;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
		}
		
		
	
		
	}
	
	.appraise-popup-title {
	    width: 100%;
	    height: 86px;
	    border-radius: 20px 20px 0 0;
	    background: #0AA26B;
	    box-sizing: border-box;
	    padding: 0 35px;
	
	    .appraise-popup-title-name {
	        font-family: 思源黑体;
	        font-size: 26px;
	        font-weight: bold;
	        line-height: normal;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 纯白 */
	        color: #FFFFFF;
	    }
	
	    img {
	        width: 56px;
	        height: 56px;
	    }
	}
	.start-popup-content {
	    background: #fff;
	    border-radius: 0 0 20px 20px;
	    box-sizing: border-box;
	    padding: 0 52px;
	
	    .start-popup-content-text1 {
	        margin-left: 173.5px;
	        margin-top: 89px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 333333 */
	        color: #333333;
	    }
	
	    .start-popup-content-timebox {
	        margin-top: 30px;
	        margin-left: 173.5px;
	
	        span {
	            margin-right: 30px;
	            font-family: 思源黑体;
	            font-size: 22px;
	            font-weight: normal;
	            line-height: 30px;
	            letter-spacing: 0em;
	
	            font-feature-settings: "kern" on;
	            /* 333333 */
	            color: #333333;
	        }
	
	        div {
	            width: 195px;
	            height: 64px;
	            border-radius: 100px;
	            opacity: 1;
	
	            background: #E5F7F1;
	
	            box-sizing: border-box;
	            border: 1px solid rgba(10, 162, 107, 0.2);
	        }
	
	    }
	
	    .start-popup-content-tipsbox {
	        margin-top: 89px;
	        margin-bottom: 75px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 确认开始学员 */
	        color: #333333
	    }
	
	    .start-popup-content-line {
	        margin-top: 30px;
	        width: 100%;
	        height: 0px;
	        opacity: 1;
	
	        border: 1px solid rgba(10, 162, 107, 0.2);
	    }
	
	    .start-popup-content-btnsbox {
	        margin-top: 31px;
	        margin-bottom: 30px;
	
	        div {
	            &:first-child {
	                margin-right: 20px;
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 灰 */
	                background: #ACBEB0;
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	
	            &:last-child {
	
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 绿 */
	                background: #0AA26B;
	
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	        }
	    }
	
	}
	
}

	.bucls3{
			cursor: pointer;
				 width: 160px;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			text-align: center;
			/* 绿 */
			background: #FFAA33;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: bold;
			line-height: 46px;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 纯白 */
			color: #FFFFFF;
			margin: 0 auto;
		}
		
		
		.bucls4{
			 cursor: pointer;
			 width: 160px;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			box-sizing: border-box;
			/* 绿 */
			border: 2px solid #0AA26B;
			text-align: center;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: normal;
			line-height: 46px;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
			margin: 0 auto;
		}

/deep/ .el-dialog__header {
    border-radius: 20px 20px 0 0;
    padding: 0;

}

/deep/ .el-dialog__body {
    border-radius: 20px;
    padding: 0;
}

/deep/ .el-dialog {
    background: transparent;
    border-radius: 20px;
    box-shadow: 0 0px 0px #ccc;

    @media screen and (min-width: 992px) {
        width: 44.114%;
    }

    @media screen and (max-width: 991px) and (min-width: 768px) {
        width: 82.395%;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
    }




}

.myzit{
		font-family: myfont;
	}
	
	.fh1{
		cursor: pointer;
		font-family: Source Han Sans;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		letter-spacing: 0em;
		font-feature-settings: "kern" on;
		/* 绿 */
		color: #0AA26B;
		width: 35px;
		height: 35px;
		line-height: 33px;
		box-sizing: border-box;
		border: 3px solid #0AA26B;
		border-radius: 32px;
	}
</style>